import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../constants/path.constant';
import { clearAuth } from '../utils/auth';
import userApi from '../services/user';

/**
 * Cụm tài khoản ở góc phải khung quản trị — thay cho nút "Đăng xuất" đang được
 * chép tay ở 8 trang.
 *
 * Vì sao là dropdown chứ không phải một cái nút: trên `StudentPageV2` nút đăng
 * xuất đang `position-absolute` đè lên tiêu đề căn giữa, nên hẹp màn hình là
 * hai thứ chồng nhau. Và đăng xuất là thứ người ta bấm vài lần một ngày, không
 * đáng chiếm một ô cố định trong thanh công cụ của một trang mà bảng mới là sản
 * phẩm.
 *
 * Bỏ hộp xác nhận "Bạn có chắc chắn muốn đăng xuất": mở menu rồi chọn mục đã là
 * hai thao tác có chủ ý, và đăng xuất nhầm thì đăng nhập lại — không mất gì.
 *
 * JWT KHÔNG chứa tên người dùng (chỉ có `sub`, `role[]`, `center`, `zalo`...),
 * nên tên phải hỏi `GET /user/`. Gọi một lần rồi nhớ lại trong phiên: khung này
 * gắn ở mọi trang, để mỗi lần điều hướng lại gọi một request là lãng phí.
 */

let tenDaBiet = null;        // nhớ trong phiên, reset khi tải lại trang
let dangHoi = null;          // tránh hai trang cùng gọi một lúc

function layTen() {
  if (tenDaBiet) return Promise.resolve(tenDaBiet);
  if (!dangHoi) {
    dangHoi = userApi
      .getUser()
      .then((res) => {
        const u = res?.data ?? res;
        tenDaBiet = u?.name || u?.userName || '';
        return tenDaBiet;
      })
      // Hỏng thì im lặng lùi về nhãn chung — không ai mất việc vì không lấy
      // được cái tên, và một toast đỏ ở góc màn hình mỗi lần đổi trang thì tệ
      // hơn nhiều so với chữ "Tài khoản".
      .catch(() => '')
      .finally(() => { dangHoi = null; });
  }
  return dangHoi;
}

export default function AccountMenu({ size = 'sm' }) {
  const [ten, setTen] = useState(tenDaBiet || '');
  const navigate = useNavigate();

  useEffect(() => {
    let con = true;
    layTen().then((t) => { if (con && t) setTen(t); });
    return () => { con = false; };
  }, []);

  const dangXuat = () => {
    clearAuth();
    // Dọn khoá cũ từ thời token cắm cứng, để lần đăng nhập sau không dính
    // trạng thái thừa trên máy đã dùng lâu.
    try { localStorage.removeItem('user-token'); } catch (_) { /* noop */ }
    tenDaBiet = null;
    window.location.href = PATH.ADMIN.LOGIN;
  };

  return (
    <Dropdown align='end'>
      <Dropdown.Toggle variant='outline-secondary' size={size} id='dat-account-menu'>
        {ten || 'Tài khoản'}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => navigate(PATH.USER.PROFILE)}>Hồ sơ</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={dangXuat}>Đăng xuất</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

/** Cho trang hồ sơ gọi sau khi đổi tên, để khung cập nhật theo. */
export function quenTenDaBiet() {
  tenDaBiet = null;
}
